import "#legacy/admin/page_builder/tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most
 *                  tools just pass the component context to their templates,
 *                  so that's the default
 *  tool.render - by default updates the tool element with markup generated by
 *                tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext
 *    and update. update is
 *  - identical to render by default, but you can override it. the update
 *    lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context
 *    value, you update your view there.
 */

/* global dragula */

(function (dragula, Event) {
  "use strict";

  var variantMediaBreakpoints;

  function getVariantMediaBreakpoints() {
    if (!variantMediaBreakpoints) {
      var rootStyle = window.getComputedStyle(document.documentElement);
      var sm = (rootStyle.getPropertyValue("--sp-ref-breakpoint-sm") || "").trim();
      var lg = (rootStyle.getPropertyValue("--sp-ref-breakpoint-lg") || "").trim();

      variantMediaBreakpoints = {
        sm: sm || "751px",
        lg: lg || "1200px",
      };
    }

    return variantMediaBreakpoints;
  }

  /**
   * Media for slideshow <picture> preview after crop. Matches
   * Components::ContentModifiers::ModifiedAsset#media_by_device (sm/lg from
   * admin :root --sp-ref-breakpoint-* , same defaults as Ruby when unset).
   */
  function variantMediaMatchingModifiedAsset(deviceType) {
    var breakpoints = getVariantMediaBreakpoints();

    if (deviceType === "phone") {
      return "(max-width: " + breakpoints.sm + ")";
    }
    if (deviceType === "tablet") {
      return "(max-width: " + breakpoints.lg + ")";
    }
    if (deviceType === "desktop") {
      return "(min-width: " + breakpoints.lg + ")";
    }
  }

  var VARIANT_CROP_FIELDS = ["height", "max_height", "max_width", "type", "width", "x_offset", "y_offset"];

  function whitelistedVariantCropFields(source) {
    source = source || {};
    var variant = {};
    jQuery.each(VARIANT_CROP_FIELDS, function (_, field) {
      variant[field] = source[field];
    });
    return variant;
  }

  function nestedVariantRatioDefaults(deviceDefaults) {
    return deviceDefaults && (deviceDefaults.none || deviceDefaults.custom || deviceDefaults.portrait);
  }

  function buildSlideDeviceVariant(deviceDefaults, cropSettings) {
    var variant = whitelistedVariantCropFields(cropSettings);

    if (variant.max_width != null || variant.max_height != null) {
      return variant;
    }

    if (!deviceDefaults) {
      return variant;
    }

    if (deviceDefaults.max_width) {
      variant.max_width = deviceDefaults.max_width;
      variant.max_height = deviceDefaults.max_height;
      return variant;
    }

    if (nestedVariantRatioDefaults(deviceDefaults)) {
      var ratioKey = cropSettings.type || "none";
      var ratioDefaults = deviceDefaults[ratioKey] || deviceDefaults.none || deviceDefaults.custom;
      if (ratioDefaults) {
        variant.max_width = ratioDefaults.width;
        variant.max_height = ratioDefaults.height;
      }
    }

    return variant;
  }

  function applyPreviewVariantFields(slides) {
    jQuery.each(slides || [], function (_, slide) {
      if (slide.id && slide.variants && !slide.isVideo) {
        jQuery.each(slide.variants, function (deviceType, variant) {
          if (variant && !variant.url) {
            variant.url = String(
              Handlebars.helpers.variantUrl(slide.id, deviceType, whitelistedVariantCropFields(variant)),
            );
            if (!variant.media) {
              variant.media = variantMediaMatchingModifiedAsset(deviceType);
            }
          }

          // The hero template's <source> elements read variant.srcset; without it they
          // render empty and the picture falls back to the uncropped base image.
          if (variant && !variant.srcset) {
            variant.srcset = variant.url;
          }
        });
      }
    });
  }

  // The hero template selects its responsive sources from derived preview fields
  // (url/media/srcset) the saved context never carries — it persists crop fields
  // only. Deriving them on the render copy makes every render path show the crops
  // (selection, sidebar controls, reorders, dialog closes) while the serialized
  // page stays clean by construction.
  Sparkle.PageBuilder.Component.addRenderContextDecorator(function (component, context) {
    jQuery.each((component.config && component.config.attributes) || {}, function (name, attribute) {
      if (!attribute || attribute.tool !== "slideshow") {
        return;
      }
      if (!context[name] || !context[name].slides) {
        return;
      }

      applyPreviewVariantFields(context[name].slides);
    });
  });

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "slideshow",

    /**
     * @description The template file to use to load and render the component.
     * @see slideshow.hbs
     */
    templateId: "slideshow-editor-template",

    /**
     * @description Unique selectors from the template to control events.
     */
    selectors: {
      container: ".slideshow-editor-container",
      slide: ".slideshow-editor-slide:not(.gu-mirror):not(.slideshow-editor-slide-add)",
      slideAddImage: '[data-slideshow-editor-behaviour="add-slide"]',
      slideAddVideo: '[data-slideshow-editor-behaviour="add-slide-video"]',
      slideRemove: '[data-slideshow-editor-behaviour="remove-slide"]',
    },

    // EVENT HANDLERS

    /**
     * @name onDrop
     * @description
     *  Handle the drop event for when slides get reordered through the draggula
     *   drag and drop handler.
     * @param {Sparkle.PageBuilder.Component} component
     */
    onSlideReorder: function (component) {
      var me = this;
      var $slideElements = jQuery(this.element).find(this.selectors.slide);
      var context = { slides: [] };

      $slideElements.each(function (i) {
        var $this = jQuery(this),
          slideIndex = null;

        // at this point we either can find an image element (most common)
        //  or a video element, so well select based on that
        var $mediaEl = $this.find("img");
        if (!$mediaEl.length) {
          $mediaEl = $this.find("video");
        }

        _.each(me.component.context.slides, function (slide, index) {
          if (slide.url === $mediaEl.attr("src")) {
            slideIndex = index;
          }
        });

        context.slides.push(me.component.context.slides[slideIndex]);
      });

      this.component.save(context);
      this.component.render();
      this.render();
      this.refreshDragContainer();
    },

    // Re-point dragula after render() replaces the container — the mirror is appended
    // to mirrorContainer at each drag start, and a detached reference leaves the
    // dragged slide invisible. Runs inside the drake's own "drop" event, so the
    // drake must not be destroyed/recreated here.
    refreshDragContainer: function () {
      var container = jQuery(this.element).find(this.selectors.container)[0];
      this.drake.containers[0] = container;
      this.dragOptions.mirrorContainer = container;
    },

    /**
     * @name onSlideClick
     * @description
     *  Handle the slide click event (trigger the edit modal).
     * @param {number} defaultSelectionIndex
     */
    onSlideClick: function (slideIndex) {
      var me = this;

      function callback(slide) {
        // ImageDialog passes null when the user clicks "Remove". Drop the slide
        // rather than writing null into context.slides, which would leave a hole
        // that truncates eachSlide and breaks buildSlideModal when reopening.
        if (!slide) {
          me.removeSlide(slideIndex);
          return;
        }

        // `slide` is the ImageDialog's value (this.getValue()) — it carries the
        // freshly selected/uploaded image and its crop variants (id, url,
        // hi_res_url, variants, …) but none of the sidebar-owned attributes. The
        // sidebar sub-tools (title, caption, alt, link, hi_res, theme, …) wrote
        // their edits onto this slide's entry in the tool context during the
        // dialog session. Merge the two: keep the dialog's image fields and
        // overlay the sidebar-owned attributes from the current slide. Copying
        // *onto* the dialog slide — rather than reset()-ing the splinter back to
        // the parent first — preserves an upload that has not yet been persisted
        // to the parent (reverting to the parent dropped it, issue scripps#8613)
        // while still restoring the sidebar edits (issue scripps#7950). Deriving
        // the field list from the slide config keeps it in sync with whatever
        // attributes each client exposes.
        var current = me.getSlide(slideIndex);
        if (current) {
          var slideAttributes = (me.component.config.slide && me.component.config.slide.attributes) || {};
          jQuery.each(slideAttributes, function (field) {
            if (current[field] !== undefined) {
              slide[field] = current[field];
            }
          });
        }

        me.setSlide(slideIndex, slide);

        // FIXME: in some situations, re-rendering is blowing away the slick
        // carousel js on the slideshow component. firing this event will
        // reload it. i don't like this solution, but slideshows are the
        // only component that suffer from this issue, so it's hard to justify
        // digging deeper to figure out the larger component and tool life
        // cycle issues that cause this for the time being.
        Event.trigger("pb:component:load", me.component);
      }

      this.buildSlideModal(slideIndex, callback).show();
    },

    onAddVideoSlideClick: function () {
      this.onAddSlideClick(true);
    },

    onAddImageSlideClick: function () {
      this.onAddSlideClick(false);
    },

    /**
     * @name onAddSlideClick
     * @description
     *  Trigger the add dialog for adding in new media to the slide show. When
     *   selection is completed, rerender both the tool and component so
     *   they stay in sync.
     */
    onAddSlideClick: function (isVideo) {
      var me = this;
      var slideIndex = this.component.context.slides.length;
      // Snapshot so a cancelled or removed add can be rolled back.
      var originalContext = JSON.parse(JSON.stringify(this.component.context));

      function callback(slide) {
        if (!slide) {
          me.component.save(originalContext); // "Remove" — discard the provisional slide
          return;
        }

        me.setSlide(slideIndex, slide);
      }

      function onCancel() {
        me.component.save(originalContext); // "X" — discard the provisional slide
      }

      // Seed the provisional slide so the dialog's sub-tools have an entry to
      // bind to. Use save() rather than setSlide()/persistAndRender():
      // persistAndRender fires "pb:tool:outdated", which swaps this tool instance
      // and orphans the closures above (a later cancel could no longer clean up).
      // save() also keeps the empty slide out of the Slides list, since the tool
      // ignores its own save events.
      var provisionalSlide = this.buildSlide(isVideo);
      this.component.context.slides[slideIndex] = provisionalSlide;
      this.component.save("slides." + slideIndex, provisionalSlide);

      this.buildSlideModal(slideIndex, callback, onCancel).show();
    },

    onRemoveSlideClick: function (event) {
      var me = this;
      swal(
        {
          title: "Please Confirm",
          text: "Are you sure you want to remove this slide?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          closeOnConfirm: true,
          closeOnCancel: true,
        },
        function () {
          me.removeSlide(jQuery(event.target).data("slide-index"));
        },
      );
    },

    // HELPER FUNCTIONS

    buildSlideModal: function (slideIndex, callback, onCancel) {
      var slide = this.getSlide(slideIndex);
      var fields = jQuery('<div class="tools">');
      var originalContext = JSON.parse(JSON.stringify(this.component.context));
      var me = this;

      // The add flow supplies its own onCancel; editing falls back to restoring
      // the context captured when the modal opened.
      var cancelHandler =
        onCancel ||
        function () {
          me.component.save(originalContext);
          me.component.render();
        };

      this.unloadSlideFieldsLoader();
      var fieldsLoader = Sparkle.PageBuilder.Tool.Loader(this.component, fields.get(0));
      fieldsLoader.load(this.component.config.slide.attributes, "slides." + slideIndex + ".");
      this.slideFieldsLoader = fieldsLoader;

      function withFieldsLoaderCleanup(handler) {
        return function () {
          try {
            return handler.apply(this, arguments);
          } finally {
            me.unloadSlideFieldsLoader(fieldsLoader);
          }
        };
      }

      var completeHandler = withFieldsLoaderCleanup(callback);
      var slideCancelHandler = withFieldsLoaderCleanup(cancelHandler);

      // Modal construction can fail after its field loader is live.
      try {
        if (slide.isVideo) {
          var pageType = "Video";
          return new Sparkle.PageBuilder.Modal.SlideEditor(slide, fields, {
            header: "Editing " + (me.config.label || "Slides"),
            onComplete: completeHandler,
            onCancel: slideCancelHandler,
            pageType: pageType,
          }).render();
        } else if (this.config.allow_device_crop) {
          var imageDialog = new Sparkle.PageBuilder.ImageDialog(slide, completeHandler, {
            variants: this.config.variants,
            cropperItems: this.config.cropper_items,
            advanced_options: false,
            // Editing keeps the no-rollback close behaviour, but the dialog's cropper
            // tabs rewrite the slide's variants on the splinter while it is open, so a
            // plain close must resync the splinter and repaint from it.
            onCancel: withFieldsLoaderCleanup(
              onCancel ||
                function () {
                  me.component.reset();
                  me.component.render();
                },
            ),
          });

          jQuery(imageDialog.content).find(".image-sidebar").empty();
          jQuery(imageDialog.content).find(".image-sidebar").append(fields);

          // Return so the callers' `.show()` chaining works like the other branches
          // (ImageDialog already shows itself on init, so the extra show() is a no-op).
          return imageDialog;
        } else {
          var pageType = "Image";
          return new Sparkle.PageBuilder.Modal.SlideEditor(slide, fields, {
            header: "Editing " + (me.config.label || "Slides"),
            onComplete: completeHandler,
            onCancel: slideCancelHandler,
            pageType: pageType,
          }).render();
        }
      } catch (error) {
        try {
          this.unloadSlideFieldsLoader(fieldsLoader);
        } catch (cleanupError) {
          console.error("Slide modal cleanup failed after a build error", cleanupError);
        }
        throw error;
      }
    },

    unloadSlideFieldsLoader: function (loader) {
      if (!this.slideFieldsLoader || (loader && this.slideFieldsLoader !== loader)) {
        return;
      }

      var fieldsLoader = this.slideFieldsLoader;
      this.slideFieldsLoader = null;
      fieldsLoader.unload();
    },

    // Builds a new slide from the asset
    buildSlide: function (isVideo, asset) {
      asset = asset || {};

      var slide = {
        id: asset.id,
        title: asset.title || "",
        caption: asset.caption || "",
        alt: asset.alt || "",
        link: { text: "", url: "" },
        url: asset.url,
        hi_res_url: asset.hi_res_url,
        hi_res: !isVideo,
        isVideo: isVideo,
      };

      return slide;
    },

    removeSlide: function (slideIndex) {
      this.component.context.slides.splice(slideIndex, 1);
      this.persistAndRender();
    },

    setSlide: function (slideIndex, slide) {
      this.component.context.slides[slideIndex] = slide;
      this.persistAndRender();
    },

    persistAndRender: function () {
      var me = this;

      // Create device variants from the single crop setting we specified. This maintains compatibility
      // with existing variant processors which were initially developed for the original image cropper
      // that allows per-device crop settings.
      this.eachSlide(function (slide) {
        if (slide.isVideo) {
          delete slide.variants;
        } else if (slide.crop_settings && me.config.variants) {
          if (me.config.allow_device_crop && slide.variants) {
            return;
          }

          var existingVariants = slide.variants;
          slide.variants = {};
          jQuery.each(me.config.variants, function (deviceType, deviceDefaults) {
            if (me.config.allow_device_crop && existingVariants && existingVariants[deviceType]) {
              slide.variants[deviceType] = whitelistedVariantCropFields(existingVariants[deviceType]);
            } else {
              slide.variants[deviceType] = buildSlideDeviceVariant(deviceDefaults, slide.crop_settings);
            }
          });
        }
      });

      // image data is a little weird right now, so we need to update
      // a secondary store where image data is kept.
      this.component.rendered.context[this.component.name] = JSON.parse(JSON.stringify(this.component.context));

      // Pass the splinter's current context explicitly. A no-arg save() persists
      // the underlying component's context, which diverges from this splinter's
      // context once reset() (below) has given it its own copy — so a slide added
      // at a new index would never reach the parent, and the reset() that follows
      // would then wipe its id/url (issue #27767).
      this.component.save(this.component.context);

      this.component.render();
      this.component.reset();

      // we need to reload the tool now to ensure the ui is re-rendered properly.
      // the loader will handle this when we call this tool 'outdated'.
      Event.trigger("pb:tool:outdated", this);

      // Update the image details shown in the sidebar
      Event.trigger("pb:tool:image:updated", this.component);
      this.render();
    },

    eachSlide: function (fn) {
      var slideIndex = 0;
      var slide;
      while ((slide = this.getSlide(slideIndex++))) {
        fn(slide);
      }
    },

    getSlide: function (slideIndex) {
      return this.component.context.slides[slideIndex];
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      // instantiate the dragula drag & drop so that we can
      //  access the event bindings and trigger the context update accordingly
      var me = this,
        $rootElement = jQuery(this.element),
        $slidesContainerElement = $rootElement.find(this.selectors.container);

      // initialize the drag and drop. The options object is retained so
      // refreshDragContainer() can re-point the container references after a
      // re-render replaces the container element.
      this.dragOptions = {
        containers: [$slidesContainerElement[0]],
        // Match by class (re-renders replace the container node after bind),
        // but only within this tool instance's element: other slideshow tools
        // otherwise also grab the drag and their drop handler saves the old
        // slide order back over the reorder.
        isContainer: function (element) {
          return me.element.contains(element) && element.classList.contains(me.selectors.container.slice(1));
        },
        mirrorContainer: $slidesContainerElement[0],

        // the 'add slide' button shouldn't be draggable.
        invalid: function (element) {
          return element.classList.contains("slideshow-editor-slide-add");
        },
      };
      this.drake = dragula(this.dragOptions);

      // bind event handlers
      this.drake.on("drop", this.onSlideReorder.bind(me));
      $rootElement.on("click", this.selectors.slide, function (event) {
        if (jQuery(event.target).closest(me.selectors.slideRemove).length) {
          return;
        }

        me.onSlideClick.call(me, jQuery(this).index());
      });
      $rootElement.on("click", this.selectors.slideAddImage, this.onAddImageSlideClick.bind(this));
      $rootElement.on("click", this.selectors.slideAddVideo, this.onAddVideoSlideClick.bind(this));
      $rootElement.on("click", this.selectors.slideRemove, this.onRemoveSlideClick.bind(this));
    },

    unbind: function (component) {
      var drake = this.drake;

      this.drake = null;
      try {
        this.unloadSlideFieldsLoader();
      } finally {
        if (drake) {
          drake.destroy();
        }
      }
    },

    shouldBeCustomizedOnClick: function () {
      return false;
    },
  });
})(dragula, Sparkle.PageBuilder.Helpers.Event);
